import React, { memo } from 'react'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import FaIcon from '../faIcon/FaIcon'

const FilterMenu = ({ value, options, onChange, to }) => {
  return (
    <Tabs
      value={value}
      sx={{ mb: { xs: 2, md: 4 } }}
      onChange={to ? null : (_, value) => onChange({ value })}
    >
      {options.map(({ label, icon, ...restProps }) => (
        <Tab
          key={label}
          label={label}
          icon={icon && <FaIcon icon={icon} size='lg' />}
          {...restProps}
        />
      ))}
    </Tabs>
  )
}

export default memo(FilterMenu)
